<template>
  <div class="box7">
    <pageTitle
      title="延伸拓展收获更多硬技能"
      text="超高价值热门课程免费送！"
      titleColor="#1A0400"
      titColor="#665552"
    />

    <div class="content">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <!-- <swiper-slide>
          <div class="content-item">
            <h1>区块链运营</h1>
            <p>(价值980元)</p>
            <ul>
              <li><i></i>什么是区块链</li>
              <li><i></i>主流数字货币与常见货币形式介绍</li>
              <li><i></i>主流数字货币交易平台与交易方式</li>
              <li><i></i>新数字货币发行方式</li>
              <li><i></i>数字货币社群的运营方式</li>
            </ul>
          </div>
        </swiper-slide> -->
        <swiper-slide>
          <div class="content-item">
            <h1>搜索引擎优化(SEO)</h1>
            <p>(价值2000元)</p>
            <ul>
              <li><i></i>解密搜索引擎的工作原理</li>
              <li><i></i>SEO必用的工具与官方平台</li>
              <li><i></i> 关键词选择三步法</li>
              <li><i></i>界面、URL、TDK优化技巧</li>
              <li><i></i>SEO站内优化</li>
              <li><i></i>代码优化</li>
              <li><i></i>状态码解读与优化</li>
              <li><i></i>网站地图设置与布局优化</li>
              <li><i></i>了解白帽SEO、灰帽SEO、黑帽SEO</li>
              <li><i></i>高级SEO优化</li>
            </ul>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="content-item">
            <h1>新媒体运营付费推广</h1>
            <p>(价值3000元)</p>
            <ul>
              <li><i></i>信息流广告入门</li>
              <li><i></i>信息流投放的平台</li>
              <li><i></i>信息流广告开户和账户设置</li>
              <li><i></i>信息流广告物料准备</li>
              <li><i></i> 信息流广告数据分析</li>
              <li><i></i> 搜索广告入门</li>
              <li><i></i>搜索广告主要平台</li>
              <li><i></i> 百度账户优化</li>
              <li><i></i>展示广告</li>
            </ul>
          </div></swiper-slide
        >
        <swiper-slide>
          <div class="content-item">
            <h1>小红书运营</h1>
            <p>(价值1000元)</p>
            <ul>
              <li><i></i>小红书运营基础知识</li>
              <li><i></i>小红书个人运营基础</li>
              <li><i></i>小红书爆文撰写</li>
              <li><i></i>小红书个人号变现</li>
              <li><i></i>小红书品牌号基础知识</li>
              <li><i></i> 企业运营小红书策略</li>
              <li><i></i> 笔记运营技巧</li>
            </ul>
          </div></swiper-slide
        >
      </swiper>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      list: [
        {
          title: "内容一：入侵检测与网络攻防",
          arr: [
            "Kali Linux操作系统实战",
            "网络防御技术",
            "网络攻击技术 ",
            "异常通信行为分析",
            "加密流量还原",
            "大项目：入侵检测与网络攻防",
          ],
        },
        {
          title: "内容二：负载均衡远程服务调用系统",
          arr: [
            "Reactor模式并发Service",
            "DNS与路由Service",
            "负载均衡代理Service",
            "信息上报Service",
            "压力测试 ",
            "大项目：lars负载均衡系统",
          ],
        },
        {
          title: "内容三：打车软件项目",
          arr: [
            "Java基础编程",
            "Android基础UI开发",
            "JNI终端编程业务 ",
            "地图编程及服务端业务",
          ],
        },
      ],
      swiperOption: {
        // loop: true, // 循环模式选项
        slidesPerView: "auto",
        // centeredSlides: true,

        pagination: {
          el: ".swiper-pagination-box7",
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.box7 {
  padding: 80px 0px 68px;
  position: relative;
  width: 100%;
  background: #ffffff;
  overflow: hidden;

  .content {
    position: relative;
    margin-top: 48px;
  }
  /deep/ .swiper-wrapper {
    padding-left: 30px;
    padding-right: 30px;
  }
  .swiper-container {
    overflow: inherit;
  }
  .swiper-slide {
    width: 472px;
    height: 626px;
    margin-right: 32px;
  }
  .swiper-slide:nth-child(3) {
    width: 504px;
  }
  .content-item {
    width: 472px;
    height: 606px;
    border-radius: 20px;
    box-sizing: border-box;
    margin-right: 30px;
    padding: 38px 40px 0 40px;
    h1 {
      display: inline-block;
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 500;

      line-height: 30px;
    }
    p {
      font-size: 24px;
      margin-top: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #1a0400;
      line-height: 24px;
      margin-left: 6px;
    }
    ul {
      margin-top: 20px;
      margin-left: 7px;
    }
    ul li {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 46px;
      display: flex;
      align-items: center;
      i {
        width: 7px;
        height: 7px;
        background: #ff5533;
        border-radius: 50%;
        display: block;
        margin-right: 14px;
      }
    }
  }
  .swiper-slide:nth-child(1) .content-item {
    background: #fff7f5;

    padding: 38px 0px 0 34px;

    i {
      background: #f53;
    }
  }
  .swiper-slide:nth-child(1) .content-item {
    background: #fff5eb;

    padding: 38px 0px 0 34px;

    i {
      background: #ff7f00;
    }
  }
  .swiper-slide:nth-child(2) .content-item {
    background: #fffbe5;

    padding: 38px 0px 0 34px;

    i {
      background: #fa0;
    }
  }
  .swiper-slide:nth-child(3) .content-item {
    background: #ebfffd;

    i {
      background: #11d9d9;
    }
  }
  .swiper-pagination-box7 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -20px;
    transform: translate(-50%, 0px);
    height: 6px;
    background: #ffab9a;
    border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: #ffab9a;
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #ff5731;
    border-radius: 3px;
  }
}
</style>
